import {
  ClipboardList,
  Home,
  House,
  KeyRound,
  Laptop,
  ShieldCheck,
  Sparkles,
  Star,
  Sun,
  Truck,
} from 'lucide-react';

export function WindIcon(props: { size?: number; strokeWidth?: number }) {
  return (
    <span
      {...props}
      aria-hidden="true"
      style={{ fontSize: '1.25rem', lineHeight: 1 }}
    >
      ≈
    </span>
  );
}

export const serviceOptions = [
  { label: 'Ménage régulier', detail: 'Pour votre quotidien', icon: Sparkles },
  { label: 'Vitres', detail: 'Pour plus de lumière', icon: Sun },
  {
    label: 'Repassage à domicile',
    detail: 'Du linge prêt à ranger',
    icon: Star,
  },
  {
    label: 'Résidence secondaire',
    detail: 'Avant votre arrivée',
    icon: House,
  },
  {
    label: 'Emménagement / déménagement',
    detail: 'Avant ou après votre départ',
    icon: KeyRound,
  },
  {
    label: 'Nettoyage de printemps',
    detail: 'Un nouveau souffle chez vous',
    icon: WindIcon,
  },
  {
    label: 'Après travaux',
    detail: 'Un intérieur remis au propre',
    icon: Sparkles,
  },
  {
    label: 'Entre deux locations',
    detail: 'Un logement accueillant',
    icon: Home,
  },
];

export const additionalServiceOptions = [
  {
    label: 'Collecte et livraison de linge repassé',
    detail: 'Récupération et retour du linge à domicile.',
    icon: Truck,
  },
  {
    label: 'Vigilance temporaire du domicile',
    detail:
      'Pendant une absence : contrôle, aération, courrier et arrosage léger selon devis.',
    icon: ShieldCheck,
  },
  {
    label: 'Assistance informatique à domicile',
    detail:
      "Aide simple pour l'utilisation d'un ordinateur, d'une tablette ou d'un smartphone.",
    icon: Laptop,
  },
  {
    label: 'Assistance administrative à domicile',
    detail:
      'Classement, démarches en ligne et courriers, sans conseil juridique, fiscal ou comptable.',
    icon: ClipboardList,
  },
];